<template>
  <div>
    <div class="card" style="padding: 2%">
      <div class="modal-header">
        <div style="display: flex; align-items: center; gap: 50px">
          <div>
            <i class="fa fa-calendar text-success" style="font-size: 50px"></i>
          </div>
          <div style="display: flex; flex-direction: column">
            <span style="font-weight: 500; font-size: 20px"
              >Gestionar programaciones masivamente</span
            >
            <small class="texto-pequeno">Gestión de programación</small>
          </div>
        </div>
      </div>
      <div class="card-content">
        <!-- <div class="row">
          <div class="col-md-3">
            <label for="cancelar_por">Cancelar por:</label>
            <select id="cancelar_por" v-model="filter" class="form-control">
              <option value="paciente">Paciente</option>
              <option value="terapeuta">Terapeuta</option>
            </select>
          </div>
        </div> -->
        <div class="row">
          <!-- <div class="col-md-3">
            <label for="paciente"
              >Selecione un
              {{ filter == "paciente" ? "paciente" : "terapeuta" }}</label
            >
            <select
              name=""
              v-if="filter == 'paciente'"
              v-model="value"
              id="paciente"
              class="form-control"
              :disabled="sesionesDisponibles != ''"
            >
              <option
                :value="paciente.id"
                v-for="paciente in listPacientes"
                :key="paciente.id"
              >
                {{ paciente.nombres }} {{ paciente.apellidos }}
              </option>
            </select>
            <select
              name=""
              v-else
              v-model="value"
              id="paciente"
              class="form-control"
              :disabled="sesionesDisponibles != ''"
            >
              <option
                v-for="Terapeuta in listTerapeutas"
                :key="Terapeuta.usuario"
                :value="Terapeuta.usuario"
              >
                {{ Terapeuta.nombres }} {{ Terapeuta.apellidos }}
              </option>
            </select>
          </div> -->
          <div class="col-md-3">
            <label style="font-weight: 400" for="fecha_inicial"
              >Seleccione una fecha para cancelar</label
            >
            <input
              type="date"
              id="fecha_inicial"
              v-model="fecha_inicial"
              class="form-control"
            />
          </div>
          <div class="col-md-3" v-if="rol == 1">
            <label style="font-weight: 400" for="fecha_inicial"
              >Tipo de programación a buscar</label
            >
            <select v-model="tipoBuscar" class="form-control">
              <option value="Sesiones">Sesiones/Evaluaciones</option>
              <option value="CYT">CYT</option>
            </select>
          </div>
          <!-- <div class="col-md-3">
            <label for="fecha_final">Fecha final:</label>
            <input
              type="date"
              id="fecha_final"
              v-model="fecha_final"
              :disabled="sesionesDisponibles != ''"
              class="form-control"
            />
          </div> -->
          <div class="col-md-2">
            <label for="" style="color: white">dd</label> <br />
            <button
              class="btn btn-success btn-fill btn-block"
              style="border-radius: 5px"
              @click="getEvents()"
            >
              Buscar sesiones
            </button>
          </div>
        </div>
        <br />
        <br />
        <div
          class="row"
          v-if="sesionesDisponibles != ''"
          style="border-radius: 10px"
        >
          <div class="col-md-12">
            <h5 style="font-size: 17px; font-weight: 500">
              Sesiones disponibles para cancelar
              <span
                style="
                  border-radius: 10px;
                  background-color: #302254;
                  color: white;
                  padding: 5px 10px;
                "
                >{{ sesionesDisponibles.length }}</span
              >
            </h5>
          </div>
          <div
            class="col-md-3"
            v-for="sesion in sesionesDisponibles"
            :key="sesion"
          >
            <div
              class="card"
              style="box-shadow: none; border: 0.1em #d4d4d4 solid"
            >
              <div class="card-content">
                <div class="row">
                  <div class="col-md-12">
                    <center>
                      <p>
                        {{ sesion.nombrePaciente }}
                        {{ sesion.apellidoPaciente }}
                      </p>
                    </center>
                  </div>
                  <div class="col-md-12">
                    <center>
                      <span>
                        Terapeuta: {{ sesion.nombreTerapeuta }}
                        {{ sesion.apellidoTerapeuta }}
                      </span>
                      <br />
                      <span>
                        <i class="fa fa-calendar"></i>
                        {{ sesion.fecha | date }}, {{ sesion.horainicio }} -
                        {{ sesion.horafin }}
                      </span>
                      <br />
                      <br />
                      <span
                        style="
                          border-radius: 50px;
                          margin-top: 30px;
                          padding: 5px 15px;
                          background-color: #302254;
                          color: white;
                        "
                      >
                        {{ sesion.ProCanSes }}
                        {{ sesion.ProCanSes > 1 ? "Sesiones" : "Sesión" }}</span
                      >
                    </center>
                    <br />
                  </div>
                  <div class="col-md-12">
                    <br />
                    <button
                      class="btn btn-secondary btn-block"
                      @click="cancelarEventos(sesion)"
                      style="border-radius: 5px"
                    >
                      Cancelar sesiones
                    </button>
                    <button
                      class="btn btn-success btn-block btn-fill"
                      @click="aceptarCYT(sesion)"
                      style="border-radius: 5px"
                      v-if="rol == 1 && sesion.tipo == 'CYT'"
                    >
                      Aceptar CYT
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import crearAlerta from "../../global-services/crearAlerta";
export default {
  data() {
    return {
      ip: "https://avanti-erp.com/",
      filter: "paciente",
      listPacientes: [],
      listTerapeutas: [],
      paciente: "",
      fecha_inicial: "",
      fecha_final: "",
      sesionesDisponibles: [],
      value: "361",
      rol: localStorage.getItem("rol"),
      tipoBuscar: "Sesiones",
    };
  },
  methods: {
    getEvents: function () {
      this.$modal.show("carga");
      const BASE_URL = `${this.ip}api/cancelacion-masiva/date/${this.fecha_inicial}/${this.tipoBuscar}`;
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          if (res.data.status == true) {
            this.sesionesDisponibles = res.data.data;
            console.log(res.data.data);
          } else {
            this.$modal.hide("carga");
            this.$notify(crearAlerta("danger", res.data.mensaje));
          }
        })
        .catch((err) => {
          this.$modal.hide("carga");
          alert(
            "Ocurrió un error al traer los eventos, por favor comunique al administrador. ERROR: " +
              err
          );
          console.log(err);
        });
    },
    getListPacientes: function () {
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const sede = localStorage.getItem("sede");
      const BASE_URL = `${this.ip}api/list-pacientes/${sede}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.listPacientes = res.data.data;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          alert(
            "Ocurrió un error al traer los pacientes, por favor comunique al administrador. ERROR: " +
              err
          );
          console.log(err);
        });
    },
    otraBusqueda: function () {
      this.sesionesDisponibles = [];
    },
    cancelarEventos: async function (evento) {
      try {
        this.$modal.show("carga");

        const eventosCancelar = {
          paciente: evento.pacienteId,
          terapeuta: evento.usuarioTerapeuta,
          fecha_inicial: this.fecha_inicial,
          usuariocancela: localStorage.getItem("usuario"),
        };

        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };

        const BASE_URL = `${this.ip}api/cancelar-eventos-masivos`;
        const { data } = await axios.post(
          BASE_URL,
          { events: eventosCancelar },
          config
        );

        this.$notify(
          crearAlerta(
            data.status ? "success" : "danger",
            data.status
              ? data.mensaje
              : "Ocurrió un error, contacte al administrador"
          )
        );
      } catch (err) {
        console.error("Error al cancelar eventos:", err);
        this.$notify(
          crearAlerta("danger", "Ocurrió un error, contacte al administrador")
        );
      } finally {
        this.$modal.hide("carga");
        this.getEvents();
      }
    },
    selectTerapeutas: function (especialidad) {
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}api/selectTerapeutasProgramar/${especialidad}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          this.listTerapeutas = res.data.data;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    aceptarCYT: function (sesion) {
    const EVENT = sesion;
    this.$modal.show("carga");
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const BASE_URL = `${this.ip}/api/aceptar-cyt-calendario`;
    axios
      .post(BASE_URL, { EVENT }, config)
      .then((res) => {
        this.$modal.hide("carga");
        if (res.data.status === true) {
          this.$notify(crearAlerta("success","CYT aceptado con éxito"));
          this.getEvents()
        }
      })
      .catch((err) => {
        this.$modal.hide("carga");
        this.$notify(crearAlerta("danger", mensaje));
        console.log(err);
        this.getEvents()
      });
  },
  },
  mounted() {
    this.getListPacientes();
    this.selectTerapeutas(1);
  },
};
</script>
<style>
#modal {
  padding-left: 10%;
  /* position: absolute; */
}
.ejemplo {
  height: 70vh;
  /* border: red solid; */
}
.tabla {
  /* height: 70%; */
  /* position: absolute; */
  display: inline-block;
  /* border: #e0e4ff 1px solid; */
  /* margin-top: 10px; */
  height: 70vh;
  overflow: scroll;
  /* width: 100vh; */
}

.tabla-2 {
  /* height: 70%; */
  /* position: absolute; */
  display: inline-block;
  /* border: #e0e4ff 1px solid; */
  /* margin-top: 10px; */
  height: 70vh;
  overflow: scroll;
  /* width: 45vh; */
}
.azul {
  color: blue;
}
.texto-pequeno {
  font-size: 17px;
  color: darkgray;
  padding: 0px !important;
  margin: 0px !important;
}

.titulo-modal {
  padding: 0;
  margin: 0;
}

/* .fc-time-grid-event{
    border-radius: 50px !important;
  } */

small {
  color: grey;
  font-size: 11px;
  /* margin-top:-3px; */
}

.event {
  /* margin-top:-3px; */
  margin-bottom: -4%;
}

.scroll {
  width: 100%;
  height: 230px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Programacion/cancelar-masivo.vue